// Dependencies

import React from 'react';

import classnames from 'classnames';
// eslint-disable-next-line lodash/import-scope
import { map } from 'lodash';
import PropTypes from 'prop-types';

// CSS
require('./locking-table.less');

const LockingTable = (props) => {
  const { className, data } = props;
  const { head, rows, importantRow } = data;

  return (
    <table className={classnames('locking-table', className)}>
      <thead>
        <tr>
          {map(head, (cell, i) => (
            <th key={i}>{cell}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {map(rows, (row, i) => (
          <tr
            key={i}
            className={importantRow === i ? 'locking-table-highlight-row' : ''}
          >
            {map(row, (cell, j) => (
              <td key={j}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

LockingTable.displayName = 'LockingTable';

LockingTable.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object.isRequired,
};

LockingTable.defaultProps = {
  className: null,
};

export default LockingTable;
